var _clipPath, _metadata;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCardVisa(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg10306",
    viewBox: "0 0 500.00001 162.81594",
    height: 162.81593,
    width: 500,
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", {
    id: "defs10308"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10271",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path10273",
    d: "m 413.742,90.435 c -0.057,-4.494 4.005,-7.002 7.065,-8.493 3.144,-1.53 4.2,-2.511 4.188,-3.879 -0.024,-2.094 -2.508,-3.018 -4.833,-3.054 -4.056,-0.063 -6.414,1.095 -8.289,1.971 l -1.461,-6.837 c 1.881,-0.867 5.364,-1.623 8.976,-1.656 8.478,0 14.025,4.185 14.055,10.674 0.033,8.235 -11.391,8.691 -11.313,12.372 0.027,1.116 1.092,2.307 3.426,2.61 1.155,0.153 4.344,0.27 7.959,-1.395 l 1.419,6.615 c -1.944,0.708 -4.443,1.386 -7.554,1.386 -7.98,0 -13.593,-4.242 -13.638,-10.314 m 34.827,9.744 c -1.548,0 -2.853,-0.903 -3.435,-2.289 l -12.111,-28.917 8.472,0 1.686,4.659 10.353,0 0.978,-4.659 7.467,0 -6.516,31.206 -6.894,0 m 1.185,-8.43 2.445,-11.718 -6.696,0 4.251,11.718 m -46.284,8.43 -6.678,-31.206 8.073,0 6.675,31.206 -8.07,0 m -11.943,0 -8.403,-21.24 -3.399,18.06 c -0.399,2.016 -1.974,3.18 -3.723,3.18 l -13.737,0 -0.192,-0.906 c 2.82,-0.612 6.024,-1.599 7.965,-2.655 1.188,-0.645 1.527,-1.209 1.917,-2.742 l 6.438,-24.903 8.532,0 13.08,31.206 -8.478,0"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient10277",
    spreadMethod: "pad",
    gradientTransform: "matrix(84.1995,31.0088,31.0088,-84.1995,19.512,-27.4192)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop10279",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#222357"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop10281",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#254aa5"
    }
  }))), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata10311"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-333.70157,-536.42431)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10267",
    transform: "matrix(4.9846856,0,0,-4.9846856,-1470.1185,1039.6264)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10271)",
    id: "g10269"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(351.611,96.896)",
    id: "g10275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path10283",
    style: {
      fill: "url(#linearGradient10277)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 98.437,36.252 120.831,-24.557 22.395,-60.809"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardVisa);
export default __webpack_public_path__ + "static/media/icon-card-visa.7a164d1c.svg";
export { ForwardRef as ReactComponent };